import { Box } from '@mui/material'
import { styled as muiStyled } from '@mui/material/styles'
import { thirdly, thirdly2, thirdly3, dark } from 'styles/theme'

// הערה: אין להשתמש כאן ב-direction מפורש — stylis-plugin-rtl הופך אותו.
// המסמך כולו RTL, כך שהילד הראשון ב-flex מוצג מימין באופן טבעי
export const PresentationStyles = muiStyled(Box)(() => ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    rowGap: 10,

    '.presentation-header': {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        flexShrink: 0,
        flexWrap: 'wrap',
        gap: 8,
        paddingBottom: 10,
        borderBottom: `1px solid ${thirdly2}`,
    },
    '.presentation-title': {
        fontSize: 20,
        fontWeight: 700,
        color: dark,
    },
    '.presentation-subtitle': {
        fontSize: 13,
        color: '#64748b',
        marginTop: 4,
        lineHeight: 1.5,
        whiteSpace: 'pre-line',
    },
    // קבוצת הבקרות בצד שמאל (מול הכותרת): בורר שנה/סמסטר + סרגל הניווט, תמיד באותה שורה.
    // הבורר מוקטן (MUI size="small" כברירת מחדל) כדי שלא יגביה את שורת הכותרת מעבר למה שהיה קודם
    '.presentation-header-controls': {
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        flexShrink: 0,
        '.MuiOutlinedInput-root': { fontSize: 13 },
        '.MuiFormLabel-root': { fontSize: 12 },
    },
    '.presentation-nav': {
        display: 'flex',
        alignItems: 'center',
        gap: 6,
    },
    // גודל ומשקל כמו טקסט הגוף בדשבורד (17/400) — ב-600 קליברי נראה כמו פונט אחר
    '.nav-counter': {
        fontSize: "14px",
        fontWeight: 400,
        color: '#64748b',
        backgroundColor: '#F2F4F7',
        borderRadius: 20,
        padding: '4px 10px',
    },
    '.nav-btn': {
        fontSize: "14px",
        fontWeight: 400,
        minWidth: 0,
        padding: '3px 12px',
        borderRadius: 20,
        border: `1px solid ${thirdly3}`,
        color: dark,
        backgroundColor: 'white',
        textTransform: 'none',
        lineHeight: 1.4,
        // חץ FA: line-height 1 מכווץ את קופסת האייקון לגובה הגליף עצמו,
        // כך ש-alignItems center ממרכז אותו באמת מול המילה (אחרת הוא יורש 1.4 ו"צף").
        // top הוא תיקון אופטי — לכייל מחדש אם משנים את גודל הטקסט של הכפתור
        'i': { fontSize: 12, lineHeight: 1, position: 'relative', top: 1 },
        '&:hover': { backgroundColor: '#f5f5f5', border: `1px solid ${thirdly3}` },
        '&.Mui-disabled': { opacity: 0.35, border: `1px solid ${thirdly3}` },
    },

    '.slide-viewport': {
        flex: 1,
        boxSizing: 'border-box',
        // עמודים ארוכים נגללים בתוך הכרטיס במקום לגלוש מעבר לתחתית המסך
        maxHeight: 'calc(100vh - 340px)',
        minHeight: 320,
        overflowY: 'auto',
        // עמודה: הגוף (flex 1) ממלא את כל הגובה וכפתור הפעולה נדחק לתחתית — בלי שטח מת
        display: 'flex',
        flexDirection: 'column',
    },

    // גוף עמוד דו-פאנלי: תוכן מימין, פאנל צד משמאל — שניהם נמתחים למלוא גובה ה-viewport
    '.slide-body': {
        flex: 1,
        display: 'flex',
        gap: 16,
        alignItems: 'stretch',
        boxSizing: 'border-box',
    },
    // יחס הצדדים : תוכן 618.5px מול פאנל צד 666.5px (כמעט חצי-חצי, הפאנל מעט רחב יותר)
    '.slide-main': {
        flex: 618,
        minWidth: 0,
    },
    // הפאנל נמתח לגובה הגוף (stretch) שממלא את כל ה-viewport — גודל אחיד בכל השקפים גם כשריק.
    // עודף תוכן נגלל בתוך הריבוע עצמו (slide-side-inner), לא גולש מעבר לעמוד הבית
    // עם נתונים: רקע תכלת #E6F0FE וקופסה לבנה ממוסגרת בפנים; ריק: #F5F9FF שטוח (כמו בעיצוב)
    '.slide-side': {
        flex: 666,
        minWidth: 0,
        backgroundColor: '#E6F0FE',
        borderRadius: 16,
        position: 'relative',
        minHeight: 280,
    },
    '.slide-side.empty-side': {
        backgroundColor: '#F5F9FF',
    },
    '.slide-side-inner': {
        position: 'absolute',
        top: 16, bottom: 16, left: 16, right: 16,
        backgroundColor: 'white',
        borderRadius: 12,
        border: `1px solid ${thirdly2}`,
        overflowY: 'auto',
        padding: '6px 12px',
        boxSizing: 'border-box',
    },
    // תצוגת "תלמידים בתכנית המדידה" — הריבוע כולו בגוון #F5F9FF (כמו רקע "אין נתונים" בפיגמה),
    // אחיד ורציף: גם המסגרת החיצונית וגם הקופסה הפנימית, בלי גבול/קופסה לבנה נפרדת
    '.slide-side.totals-view': {
        backgroundColor: '#F5F9FF',
    },
    '.slide-side-inner.totals-view': {
        backgroundColor: '#F5F9FF',
        border: 'none',
    },
    '.side-empty': {
        position: 'absolute',
        top: 0, bottom: 0, left: 0, right: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#94a3b8',
        fontSize: 14,
    },

    // כפתור הפעולה של העמוד — בתחתית, בצד שמאל (flex-end ב-RTL), כהה כמו בעיצוב
    '.slide-action-row': {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: 12,
    },
    '.slide-action-btn': {
        fontSize: 13,
        fontWeight: 600,
        minWidth: 0,
        padding: '5px 14px',
        borderRadius: 8,
        color: 'white',
        backgroundColor: dark,
        textTransform: 'none',
        lineHeight: 1.4,
        '&:hover': { backgroundColor: dark, opacity: 0.9 },
        '&.Mui-disabled': { opacity: 0.35, color: 'white' },
    },

    '.slide-loading': {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 250,
    },

    // שורת מוסד בפאנלי הצד (נתוני ביצוע / סטטיסטיקות) — כמו בעמודים המקוריים, מוקטן
    '.mini-bar-row': {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        padding: '7px 2px',
    },
    '.mini-bar-label': {
        width: 100,
        flexShrink: 0,
        fontSize: 12,
        color: dark,
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        justifyContent: 'space-between',
    },
    '.mini-bar-name': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    '.mini-bar-content': {
        flex: 1,
        minWidth: 0,
        display: 'flex',
        flexDirection: 'column',
        rowGap: 3,
    },
    '.mini-bar-caption': {
        fontSize: 11,
        color: dark,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    '.mini-bar-track': {
        width: '100%',
        height: 18,
        backgroundColor: '#F2F4F7',
        display: 'flex',
        // עיגון המילוי לשמאל כמו בפיגמה — ב-RTL סוף הציר הוא שמאל
        justifyContent: 'flex-end',
        overflow: 'hidden',
        borderRadius: 3,
    },
    '.mini-bar-fill': {
        height: '100%',
        backgroundColor: thirdly,
    },
    '.mini-bar-expected': {
        height: '100%',
        backgroundColor: '#E4F2D1',
        color: '#50B02B',
        fontSize: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 4px',
        boxSizing: 'border-box',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    },
    '.mini-bar-unexpected': {
        height: '100%',
        backgroundColor: '#FBD9DA',
        color: '#e86e5e',
        fontSize: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 4px',
        boxSizing: 'border-box',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    },

    // עמוד הפתיחה — כרטיס בהיר (כמו בפיגמה); טקסט+כפתור בזרימה רגילה למעלה,
    // הקריקטורה מעוגנת בפינה הימנית-תחתונה (overflow hidden חותך אותה בקצה הכרטיס, כמו בפיגמה)
    '.cover-layout': {
        height: '100%',
        position: 'relative',
        overflow: 'hidden',
        background: '#F5F9FF',
        borderRadius: 16,
        boxSizing: 'border-box',
        // paddingInlineStart/End (ולא shorthand פיזי) כדי שהרווח הנוסף יישאר בצד הנכון תחת RTL
        paddingBlock: 24,
        paddingInlineStart: 48,
        paddingInlineEnd: 24,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
        rowGap: 16,
    },
    '.cover-text': {
        fontSize: 20,
        color: '#404F69',
        lineHeight: 1.35,
        maxWidth: 380,
    },
    '.cover-title': {
        fontWeight: 700,
    },
    '.cover-btn': {
        fontSize: 16,
        fontWeight: 400,
        minWidth: 0,
        padding: '6px 16px',
        borderRadius: 8,
        color: 'white',
        backgroundColor: dark,
        textTransform: 'none',
        lineHeight: 1.4,
        zIndex: 1,
        '&:hover': { backgroundColor: dark, opacity: 0.9 },
    },
    '.cover-cartoon': {
        position: 'absolute',
        bottom: 0,
        insetInlineEnd: 48,
        height: '62%',
        maxHeight: 240,
        // Img גלובלי הוא width:100% — כאן הגובה קובע והרוחב נגזר ממנו
        img: { width: 'auto', height: '100%' },
    },

    // פאנל צד לעמוד הפתיחה — כרטיס גרף הדירוגים כמו בדשבורד הרגיל, מוקטן שיכנס בלי גלילה.
    // הדריסה של card-title/wrap-card-title ממוקדת ל-.rating-side בלבד (ספציפיות גבוהה יותר
    // מ-.card-title המקורי ב-Dashboard/Style.js) כדי לא להשפיע על הכרטיס הרגיל בדשבורד
    '.rating-side': {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        rowGap: 6,
        boxSizing: 'border-box',
        '.wrap-card-title': { flexShrink: 0 },
        '.card-title': { height: 22, fontSize: 14, columnGap: 6 },
    },

    // כרטיסי נתונים (עמוד "מי נמדד") — לפי ה-CSS מהעיצוב: radius 16, padding 16, gap 8
    '.stat-cards': {
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: 12,
        height: '100%',
        boxSizing: 'border-box',
    },
    '.stat-card': {
        background: '#FBFDFF',
        border: `1px solid ${thirdly2}`,
        borderRadius: 16,
        padding: 14,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        rowGap: 6,
        minHeight: 140,
        boxSizing: 'border-box',
    },
    // כרטיס לא לחיץ 
    '.stat-card:not(.clickable)': {
        background: 'white',
    },
    '.stat-card.clickable': {
        cursor: 'pointer',
        transition: 'box-shadow 0.15s',
        '&:hover': { boxShadow: '0 2px 10px rgba(44,132,255,0.15)' },
    },
    // כרטיס פעיל
    '.stat-card.active': {
        border: '1px solid var(--Info-2-400, #85B6FF)'

    },

    // גרף הסה"כ בפאנל הצד (עמוד "מי נמדד", תצוגת "תלמידים בתכנית המדידה") — יושב ישירות
    // על רקע התכלת (בלי קופסה לבנה), לכן ה-padding כאן הוא גם המרווח הכולל מקצוות הריבוע
    '.totals-chart': {
        height: '100%',
        boxSizing: 'border-box',
        padding: '20px 20px 16px 16px',
        position: 'relative',
    },
    // "אין עדיין תוצאות" — כשאין תלמידים בתכנית, במקום גרף עם ציר ריק (תואם ל-.side-empty, פאנל צד ריק בשאר השקפים)
    '.totals-empty': {
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#94a3b8',
        fontSize: 14,
    },
    // עטיפה פנימית — נקודת הייחוס למיקום תוויות ה-HTML (קואורדינטות ה-chartArea יחסיות לקנבס)
    '.totals-chart-inner': {
        position: 'relative',
        height: '100%',
    },
    // תווית לצד מקטע בעמודה: המספר מודגש (700), שאר השורות רגילות (400).
    // הטקסט מיושר לשמאל אבל בגלל שזה הופך זה כיאלו לימין ונראה שמאל

    '.totals-bar-label': {
        position: 'absolute',
        transform: 'translateY(-50%)',
        width: 'max-content',
        fontSize: 13,
        color: dark,
        lineHeight: 1.35,
        textAlign: 'right',
        pointerEvents: 'none',
        'b': { fontWeight: 700 },
        'div': { fontWeight: 400 },
    },
    '.stat-value': {
        fontSize: 28,
        fontWeight: 700,
        color: dark,
    },
    '.stat-label': {
        fontSize: 14,
        fontWeight: 600,
        color: dark,
        display: 'flex',
        alignItems: 'center',
        gap: 6,
    },
    '.stat-sub': {
        fontSize: 12,
        color: '#94a3b8',
    },

    // עמוד "מה נבדק" — התוכן נמתח לגובה הפאנל הצדדי; שתי הסקציות מתחלקות שווה בגובה
    '.categories-layout': {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        rowGap: 8,
        boxSizing: 'border-box',
    },
    '.category-section': {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
    },
    '.category-section-title': {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        fontWeight: 700,
        fontSize: 14,
        color: dark,
        margin: '0 0 8px',
        flexShrink: 0,
        // אייקון FA (cubes/wave-square) — אותו צבע כמו הכותרת (Text/primary)
        'i': { fontSize: 16 },
    },
    '.category-chip': {
        border: `1px solid ${thirdly3}`,
        borderRadius: 20,
        background: 'white',
        padding: '2px 12px',
        fontSize: 12,
        fontWeight: 600,
    },
    '.category-cards': {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: 8,
        flex: 1,
        minHeight: 0,
    },
    '.category-card': {
        background: 'white',
        border: `1px solid ${thirdly2}`,
        borderRadius: 16,
        padding: 10,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        rowGap: 5,
        boxSizing: 'border-box',
        minHeight: 0,
    },
    // צבע התואם ל-Info-2-500 מהפיגמה — לאותיות/ניקוד (iconText) ולאייקוני FA כאחד
    '.category-icon': {
        width: 28,
        height: 28,
        borderRadius: '50%',
        border: '1px solid var(--Info-2-500, #569AFF)',
        color: '#569AFF',
        background: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 13,
        fontWeight: 400,
        flexShrink: 0,
    },
    '.category-name': {
        fontWeight: 700,
        fontSize: 14,
        color: dark,
    },
    '.category-description': {
        fontSize: 12,
        color: '#64748b',
        lineHeight: 1.35,
    },
    '.category-grades': {
        fontSize: 11,
        color: '#64748b',
        border: `1px solid ${thirdly3}`,
        borderRadius: 20,
        background: 'white',
        padding: '1px 10px',
        whiteSpace: 'nowrap',
    },

    // עמוד "תוצאות הקריאה" — עטיפה שנמתחת לגובה הפאנל; שלושת הבלוקים
    // (חלוקה כללית / התפלגות / מקרא) מתפזרים על מלוא הגובה
    '.results-layout': {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        rowGap: 8,
        boxSizing: 'border-box',
    },
    // שורה עם תווית צד מימין (כמו בפיגמה): "חלוקה כללית..." ליד הכרטיסים, "התפלגות..." ליד הגרף
    '.labeled-row': {
        display: 'flex',
        gap: 16,
        alignItems: 'flex-start',
    },
    '.row-side-label': {
        width: 108,
        flexShrink: 0,
        fontSize: 14,
        fontWeight: 700,
        color: dark,
        lineHeight: 1.5,
        paddingTop: 4,
    },
    '.labeled-row-content': {
        flex: 1,
        minWidth: 0,
    },
    // אותו מרווח כמו בין החיצים (8) כדי שהכרטיסים והחיצים שמתחתיהם יישארו מיושרים
    '.macro-split': {
        display: 'flex',
        columnGap: 8,
        flex: 1,
        minWidth: 0,
        alignItems: 'stretch',
    },
    // רוחב כל כרטיס נקבע inline לפי splitWidths — תמיד זהה לרוחב החץ המקווקו שמתחתיו
    '.macro-card': {
        border: `1px solid ${thirdly2}`,
        borderRadius: 12,
        padding: 12,
        display: 'flex',
        flexDirection: 'column',
        rowGap: 8,
        boxSizing: 'border-box',
        minWidth: 0,
    },
    '.macro-pct': {
        fontSize: 30,
        fontWeight: 700,
        lineHeight: 1.1,
    },
    // ה"פס" הצבעוני שלפני שם האגף (pipe בפיגמה: 3x24 מעוגל)
    '.macro-pipe': {
        display: 'inline-block',
        width: 3,
        height: 16,
        borderRadius: 2,
        flexShrink: 0,
    },
    '.macro-label': {
        fontWeight: 700,
        fontSize: 15,
        color: dark,
        display: 'flex',
        alignItems: 'center',
        gap: 6,
    },
    '.macro-note': {
        fontSize: 12,
        color: '#404F69',
        lineHeight: 1.4,
    },

    // מקרא (עמוד "תוצאות הקריאה") — ריבוע צבע + שם הדירוג + אחוז/כמות/תיאור בשורה אחת
    '.results-legend': {
        display: 'flex',
        flexDirection: 'column',
        rowGap: 5,
    },
    '.legend-title': {
        fontWeight: 700,
        fontSize: 14,
        color: dark,
    },
    '.legend-item': {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        fontSize: 13,
        color: dark,
    },
    '.legend-swatch': {
        width: 12,
        height: 12,
        borderRadius: 2,
        flexShrink: 0,
    },
    '.legend-text': {
        minWidth: 0,
    },

    // סוגריים מקווקוים מעל פס ההתפלגות — ירוק מעל הקוראים, אדום מעל המתקשים
    '.distribution-brackets': {
        display: 'flex',
        columnGap: 8,
        marginBottom: 8,
    },
    // חיצים דינאמיים
    '.distribution-bracket': {
        height: 22,
        position: 'relative',
        border: '1.5px dashed currentColor',
        borderBottom: 'none',
        borderRadius: '8px 8px 0 0',
        boxSizing: 'border-box',
    },
    '.bracket-arrow': {
        position: 'absolute',
        bottom: -4,
        color: 'inherit',
    },
    '.bracket-arrow-right': { right: -4 },
    '.bracket-arrow-left': { left: -4 },

    // בלוקים צבעוניים בגובה קבוע; הפינות מעוגלות רק בקצוות הגרף
    '.distribution-blocks': {
        display: 'flex',
        width: '100%',
        borderRadius: 8,
        overflow: 'hidden',
    },
    '.distribution-block': {
        height: 80,
        minWidth: 56,
        boxSizing: 'border-box',
        padding: '8px 4px 6px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        overflow: 'hidden',
    },
    '.block-pct': {
        fontSize: 15,
        fontWeight: 700,
    },
    '.block-count': {
        fontSize: 11,
        fontWeight: 400,
        whiteSpace: 'nowrap',
    },
    '.distribution-labels': {
        display: 'flex',
        marginTop: 6,
    },
    '.distribution-label-item': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        rowGap: 3,
        minWidth: 56,
        fontSize: 12,
    },
    '.tier-chip': {
        display: 'inline-flex',
        alignItems: 'center',
        columnGap: 4,
        borderRadius: 12,
        padding: '1px 10px',
        fontSize: 11,
        fontWeight: 600,
        whiteSpace: 'nowrap',
    },
    '.tier-description': {
        color: '#64748b',
        fontSize: 10.5,
        textAlign: 'center',
        lineHeight: 1.3,
        maxWidth: 110,
    },

    '.info-callout': {
        display: 'flex',
        alignItems: 'flex-start',
        columnGap: 8,
        background: '#EAF2FF',
        borderRadius: 10,
        padding: '6px 12px',
        fontSize: 12.5,
        color: '#2C84FF',
        lineHeight: 1.45,
        margin: '6px 0',
    },
    '.callout-icon': {
        fontSize: 17,
        marginTop: 2,
        flexShrink: 0,
    },
    // קו מפריד מעל הערת השוליים (כמו בפיגמה)
    '.slide-divider': {
        borderTop: '1px solid #E5E7EB',
        margin: '6px 0',
    },
    '.slide-footnote': {
        fontSize: 12,
        color: '#64748b',
    },

    // עמודי "הצעדים הבאים" — עטיפה שנמתחת לגובה הפאנל; הסקציה האחרונה מתרחבת למלא את הנותר
    '.steps-layout': {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        rowGap: 8,
        boxSizing: 'border-box',
        '.info-callout': { margin: 0 },
        '.numbered-section': { marginBottom: 0 },
        '.numbered-section:last-child': { flex: 1, minHeight: 0 },
    },
    '.numbered-section': {
        background: 'white',
        border: '1px solid #E5E7EB',
        borderRadius: 12,
        padding: 10,
        marginBottom: 14,
        boxSizing: 'border-box',
    },
    '.numbered-section-header': {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        marginBottom: 6,
    },
    '.section-number': {
        background: dark,
        color: 'white',
        borderRadius: 10,
        padding: '2px 10px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 12,
        fontWeight: 700,
        flexShrink: 0,
    },
    '.section-title': {
        fontWeight: 700,
        fontSize: 14,
        color: dark,
        flex: 1,
    },
    '.section-total': {
        fontWeight: 700,
        fontSize: 15,
        color: dark,
    },
    '.slide-subtitle': {
        fontSize: 12,
        color: '#64748b',
        marginBottom: 6,
    },

    '.tier-needs-cards': {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: 8,
    },
    // רקע הכרטיס מגיע inline לפי צבע הדירוג; מסגרת אפורה קבועה כמו בפיגמה
    '.tier-needs-card': {
        border: '1px solid #E5E7EB',
        borderRadius: 8,
        padding: 8,
        display: 'flex',
        flexDirection: 'column',
        rowGap: 6,
        fontSize: 12,
    },
    '.tier-needs-header': {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontWeight: 700,
    },
    // כרטיס "מענים" (עמוד 5 סקציה 02) — רק פס הכותרת צבוע, הגוף לבן (כמו בפיגמה)
    '.tier-needs-card.split-card': {
        padding: 0,
        rowGap: 0,
        backgroundColor: 'white',
        overflow: 'hidden',
        '.tier-needs-header': { padding: '8px 10px' },
        '.program-boxes': { padding: 8 },
    },
    '.program-boxes': {
        display: 'flex',
        gap: 6,
    },
    '.program-box': {
        flex: 1,
        background: 'white',
        border: '1px solid #E5E7EB',
        borderRadius: 8,
        padding: '4px 4px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        rowGap: 3,
        fontSize: 11.5,
    },
    '.program-name': {
        color: '#64748b',
    },
    '.program-value': {
        fontWeight: 700,
        fontSize: 13,
        color: dark,
    },

    '.no-data-section': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#94a3b8',
        fontSize: 14,
        padding: 20,
    },
}))
